export const dashboardKeys = {
    dashboardPlanSteps: "dashboardPlanSteps",
    updateDashboardPlanStep: "updateDashboardPlanStep",
} as const;

export const userKeys = {
    users: "users",
    currentUser: "currentUser",
    currentUserNoTenant: "currentUserNoTenant",
    currentUserOrgsAtom: "currentUserOrgsAtom",
} as const;

export const versionKeys = {
    bulkS3FileUploadToS3: "bulkS3FileUploadToS3",
    createManyVersions: "createManyVersions",
    createOrUpdateManyVersionsFromBulkS3FilesUpload:
        "createOrUpdateManyVersionsFromBulkS3FilesUpload",
    versionByDocumentURL: "versionByDocumentURL",
    updateVersionCheck: "updateVersionCheck",
    requestForApproval: "requestForApproval",
    reject: "reject",
    setToDraft: "setToDraft",
    updateFinalFile: "updateFinalFile",
    deleteS3File: "deleteS3File",
    deleteS3Files: "deleteS3Files",
    updateExpiresAtDate: "updateExpiresAtDate",
    aiCheck: (versionId?: string) => ["aiCheck", versionId],
} as const;

export const themeKeys = {
    themes: "themes",
};

export const tagKeys = {
    tags: "tags",
    createTag: "createTag",
    updateTag: "updateTag",
    deleteTag: "deleteTag",
};

export const documentKeys = {
    GetDocumentsV2: "GetDocumentsV2",
    createCustomDocument: "createCustomDocument",
    documentsForSearch: "documentsForSearch",
    updateManyDocuments: "updateManyDocuments",
} as const;

export const frameworkKeys = {
    frameworks: "frameworks",
} as const;

export const unitKeys = {
    units: "units",
} as const;
